/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logo-bg[_ngcontent-%COMP%]{fill:var(--main-color)}.logo-bg--ebox[_ngcontent-%COMP%]{opacity:.25;position:absolute;top:-45px;right:0;z-index:-1;display:none;width:10rem;height:auto}@media screen and (min-width:1280px){.logo-bg--ebox[_ngcontent-%COMP%]{top:.923rem;display:block}}"];
export { styles as styles };
